<div class="flex flex-col items-center">
  <button class="text-lg font-semibold text-grey-500 my-[33px] w-full" (click)="edit()">Edit link</button>
  <button
    (click)="onClick()"
    class="text-lg font-semibold my-[33px] w-full"
    [ngClass]="{ 'text-bey-red': link?.is_active, 'text-grey-500': !link?.is_active }">
    {{ content }}
  </button>
</div>
